import * as Backbone from "backbone";
import {CachingCollection} from "./_BaseCollection";

export interface BacnetDiscoveryRecord {
    id: number;
    sensor_id: number

    mac_address: string;
    device_address: number;
    network_number: number;
    object_id: number;
    object_id_idx: number;
    property_number: number;
    data_type: number
    value: number
    str_value: string;

    created: string;
    modified: string;
}

interface BacnetDiscoveryCollectionOptions {
    sensorId: number
}

export class BacnetDiscoveryCollection extends CachingCollection<Backbone.Model> {
    sensorId: number;

    url = () => {
        return window.location.origin + '/api/v1/sensor/' + this.sensorId + '/bacnet_discovery';
    };

    constructor(initialModels: Object[] | any[], options: BacnetDiscoveryCollectionOptions) {
        super(initialModels, options);
        this.sensorId = options.sensorId;
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/collections/BacnetDiscoveries.ts